var _style, _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuWhite57(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-white-57_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".menu-white-57_svg__st8{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 217,
    r: 32.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 512,
    r: 32.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 807,
    r: 32.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983 544.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5zM983 839.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5zM983 249.5H165.1c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5H983c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.5 32.5z"
  })));
}

export default SvgMenuWhite57;